<template>
    <div>
        <div class="head">
            <el-breadcrumb style="margin-left:20px" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/processManager'}">全流程安全生产</el-breadcrumb-item>
                <el-breadcrumb-item>巡检管理</el-breadcrumb-item>
                <el-breadcrumb-item>巡检点</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content">
            <div style="display: flex;width: 100%;justify-content: space-between;">
                <el-button type="primary" @click="handAdd()" size="small">新建</el-button>
                <Input search enter-button placeholder=" 请输入名称" v-model="fileNameOrTag" @on-search="getData(1)" style="width: 300px"/>
            </div>
            <div style="margin-top: 20px;">
                <template>
                    <el-table :data="tableData" style="width: 100%">
                        <el-table-column prop="number" label="编号"></el-table-column>
                        <el-table-column prop="name" label="名称"></el-table-column>

                        <el-table-column prop="gmtCreate" label="创建时间"></el-table-column>
                        <el-table-column prop="oper" label="操作" width="180">
                            <template slot-scope="scope">
                                <el-popover >
                                    <div slot="reference" class="name-wrapper">
                                        <el-link type="primary" @click="handleEdit(scope.row)">编辑</el-link>
                                        |
                                        <el-link type="danger" @click="handleDel(scope.row.id)">删除</el-link>
                                    </div>
                                </el-popover>
                            </template>
                        </el-table-column>
                    </el-table>

                    <div style="text-align: right;margin-top: 10px">
                      <Page :total="total" :page-size="sizePage"
                          @on-change="getData"/>
                    </div>

                </template>
            </div>
        </div>

    </div>
</template>

<script>
    import {getList, postInfo} from "../process/api/http";

    export default {
        data() {
            return {
                total: 0,
                sizePage: 10,
                currentPage: 1,
                tableData: [
                ],
                fileNameOrTag: ''
            };
        },
        // created() {
        //     this.getEmployeeList(1, 10);
        // },
        mounted:function(){
          this.getData(1);
        },
        methods: {
            getData(page){
              this.currentPage = page
                let param ={};
                param.limit = this.sizePage;
                param.curPage = page;
                param.name = this.fileNameOrTag;
                this.componentsMoudel.httpRequest
                    .getRequestHander(this.componentsMoudel.getData("urls").getinspectioncheckpoint)
                    .openLoad()
                    .startPost(param)
                    .then((res) => {
                        this.tableData = res.body.data;
                        // this.currentPage = res.body.page;
                        this.total = res.body.cum;
                        this.pageTotal = res.body.pageTotal;
                    });
            },
            handAdd(){
                this.$router.push({
                    path: "addInsPoint",
                });
            },
            // handleSizeChange(val) {
            //     this.sizePage = val;
            //     this.getEmployeeList(this.currentPage, this.sizePage);
            // },
            // handleCurrentChange(val) {
            //     this.currentPage = val;
            //     this.getEmployeeList(this.currentPage, this.sizePage);
            // },
            handleEdit(row) {
                this.$router.push({
                    name: "AddInsPoint",
                    params: {key: row},
                });
            },
            handleDel(id) {
              this.$confirm('删除该巡检点, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.componentsMoudel.httpRequest
                  .getRequestHander("/inspectioncheckpoint/delete/"+id)
                  .openLoad()
                  .startDel()
                  .then((res) => {
                      this.$message({
                          showClose: true,
                          message: "删除成功",
                          type: "success",
                      });
                      if(this.currentPage > 1 && this.tableData.length <= 1) {
                        this.currentPage -= 1
                      }
                      this.getData(this.currentPage);
                  });
              }).catch(() => {
                return        
              });
            },
        },
    };
</script>

<style scoped>
    .myHead {
        position: absolute;
        top: 0px;
        left: 250px;
        width: 80%;
        height: 60px;
    }

    .addBtn {
        position: absolute;
        top: 10px;
        right: 10px;
    }
</style>
